/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Rekam_S1Inputs */

const en_tut_rekam_s1 = /** @type {(inputs: Tut_Rekam_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before joining, each participant ticks consent to audiovisual recording for that visit.`)
};

const id_tut_rekam_s1 = /** @type {(inputs: Tut_Rekam_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebelum bergabung, peserta mencentang persetujuan rekaman audiovisual untuk kunjungan itu.`)
};

/**
* | output |
* | --- |
* | "Before joining, each participant ticks consent to audiovisual recording for that visit." |
*
* @param {Tut_Rekam_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_rekam_s1 = /** @type {((inputs?: Tut_Rekam_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Rekam_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_rekam_s1(inputs)
	return en_tut_rekam_s1(inputs)
});